import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
export const isValidRecipient = recipient => isValidBase(recipient) && validateProps(recipient, ['metaSiteId']);
export const recipientApiToRecipientEntity = recipient => {
  if (!recipient) {
    throw new Error('recipient undefined', {
      cause: {
        recipient
      }
    });
  }
  const convertedRecipient = {
    id: recipient.id,
    revision: recipient.revision,
    createdDate: recipient.createdDate,
    updatedDate: recipient.updatedDate,
    name: recipient.name,
    email: recipient.email,
    phone: recipient.phone,
    metaSiteId: recipient.metaSiteId,
    activeWhatsappConversationId: recipient.activeWhatsappConversationId,
    activeSmsConversationId: recipient.activeSmsConversationId,
    finishedOnboarding: recipient.finishedOnboarding,
    associatedMetaSiteIds: recipient.associatedMetaSiteIds ?? [],
    preferredCommunicationChannel: recipient.preferredCommunicationChannel
  };
  if (isValidRecipient(convertedRecipient)) {
    return convertedRecipient;
  }
  throw new Error('Invalid recipient data', {
    cause: {
      recipient
    }
  });
};

// createdDate/updatedDate/id/revision/metaSiteId are readOnly on the proto (server-set),
// so the generated RecipientCreate omits them — only send the writable fields on create.
export const recipientEntityToRecipientApi = recipient => ({
  name: recipient.name,
  email: recipient.email,
  phone: recipient.phone,
  activeWhatsappConversationId: recipient.activeWhatsappConversationId ?? undefined,
  activeSmsConversationId: recipient.activeSmsConversationId ?? undefined,
  finishedOnboarding: recipient.finishedOnboarding,
  associatedMetaSiteIds: recipient.associatedMetaSiteIds,
  preferredCommunicationChannel: recipient.preferredCommunicationChannel
});
//# sourceMappingURL=Recipient.js.map